"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityValueAssignments = exports.EntityValueAssignmentsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var icon_1 = require("../../components/elements/icon");
var link_icon_glyph_1 = require("../../components/icons/link-icon-glyph");
var use_lang_1 = require("../../hooks/use-lang");
var lodash_1 = require("lodash");
var entity_value_1 = require("../../components/entities/entity-value");
var cls = (0, utils_1.classNames)('entity-value-assignments');
exports.EntityValueAssignmentsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: ", ";\n    \n  "], ["\n    font-size: ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: ", ";\n    \n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.UNIT(4))
});
var LinkIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 300;\n    font-size: ", "em;\n    text-transform: uppercase;\n    color: ", ";\n  "], ["\n    margin: 0;\n    font-weight: 300;\n    font-size: ", "em;\n    text-transform: uppercase;\n    color: ", ";\n  "])), 11 / 15, theme_1.theme.COLOR('subtle'))
});
var ValuesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    gap: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LinkIcon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LinkIconStyles),
  Label: styled_components_1.default.h2(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Values: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ValuesStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
var EntityValueAssignments = function (props) {
  var className = props.className,
    children = props.children,
    fieldName = props.fieldName,
    entity = props.entity;
  var t = (0, use_lang_1.useLang)();
  var fieldValue = (0, utils_1.toArray)(entity === null || entity === void 0 ? void 0 : entity[fieldName]);
  if (!fieldValue.length) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Label, null, t('Connected To')), react_1.default.createElement(My.LinkIcon, {
    size: 28,
    color: "textSubtle"
  }, react_1.default.createElement(link_icon_glyph_1.LinkIconGlyph, null)), react_1.default.createElement(My.Values, null, (0, lodash_1.map)(fieldValue, function (value, index) {
    return react_1.default.createElement(My.Value, {
      variant: 'small',
      key: index,
      entity: value
    });
  })));
};
exports.EntityValueAssignments = EntityValueAssignments;
exports.EntityValueAssignments.defaultProps = exports.EntityValueAssignmentsDefaultProps;
exports.EntityValueAssignments.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;